export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <mask
        id="mask0_745_9552"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <rect x="0.275391" y="0.647217" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_745_9552)">
        <path
          d="M7.27604 14.8137L6.10938 13.6471L9.10938 10.6471L6.10938 7.66789L7.27604 6.50122L10.276 9.50122L13.2552 6.50122L14.4219 7.66789L11.4219 10.6471L14.4219 13.6471L13.2552 14.8137L10.276 11.8137L7.27604 14.8137Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TooltipIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <mask
        id="mask0_781_7403"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <rect
          x="0.00390625"
          y="0.665771"
          width="20"
          height="20"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_781_7403)">
        <path
          d="M9.16992 14.8325H10.8366V9.83252H9.16992V14.8325ZM10.0033 8.16585C10.2394 8.16585 10.4373 8.08599 10.597 7.92627C10.7567 7.76655 10.8366 7.56863 10.8366 7.33252C10.8366 7.09641 10.7567 6.89849 10.597 6.73877C10.4373 6.57905 10.2394 6.49919 10.0033 6.49919C9.76714 6.49919 9.56923 6.57905 9.40951 6.73877C9.24978 6.89849 9.16992 7.09641 9.16992 7.33252C9.16992 7.56863 9.24978 7.76655 9.40951 7.92627C9.56923 8.08599 9.76714 8.16585 10.0033 8.16585ZM10.0033 18.9992C8.85048 18.9992 7.76714 18.7804 6.75325 18.3429C5.73937 17.9054 4.85742 17.3117 4.10742 16.5617C3.35742 15.8117 2.76367 14.9297 2.32617 13.9159C1.88867 12.902 1.66992 11.8186 1.66992 10.6659C1.66992 9.51307 1.88867 8.42974 2.32617 7.41585C2.76367 6.40196 3.35742 5.52002 4.10742 4.77002C4.85742 4.02002 5.73937 3.42627 6.75325 2.98877C7.76714 2.55127 8.85048 2.33252 10.0033 2.33252C11.156 2.33252 12.2394 2.55127 13.2533 2.98877C14.2671 3.42627 15.1491 4.02002 15.8991 4.77002C16.6491 5.52002 17.2428 6.40196 17.6803 7.41585C18.1178 8.42974 18.3366 9.51307 18.3366 10.6659C18.3366 11.8186 18.1178 12.902 17.6803 13.9159C17.2428 14.9297 16.6491 15.8117 15.8991 16.5617C15.1491 17.3117 14.2671 17.9054 13.2533 18.3429C12.2394 18.7804 11.156 18.9992 10.0033 18.9992ZM10.0033 17.3325C11.8644 17.3325 13.4408 16.6867 14.7324 15.395C16.0241 14.1034 16.6699 12.527 16.6699 10.6659C16.6699 8.80474 16.0241 7.22835 14.7324 5.93669C13.4408 4.64502 11.8644 3.99919 10.0033 3.99919C8.14214 3.99919 6.56576 4.64502 5.27409 5.93669C3.98242 7.22835 3.33659 8.80474 3.33659 10.6659C3.33659 12.527 3.98242 14.1034 5.27409 15.395C6.56576 16.6867 8.14214 17.3325 10.0033 17.3325Z"
          fill="#003142"
        />
      </g>
    </svg>
  );
};
